import React, { Component } from 'react';
// import AnalyticsManager from '../../functions/analytics';
import RecurveBaseComponent from '../RecurveBaseComponent';
import GoogleAnalytics from "../../analytics/google";

const CategoryContext = React.createContext({
    items: [],
    loading: true,
    hasServerError: false,
    hasPopupError: false,
    imageUrl: ''
});
class Category extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            hasServerError: false,
            hasPopupError: false,
            imageUrl: ''
        };
        this.parseServerData = this.parseServerData.bind(this);
    }

    componentDidMount() {
        fetch(`${document.location}/api`).then( (response) => {
            if(response.status > 300 && response.status < 400) document.location.reload() //Follow redirects
            if(response.ok) {
                response.json().then( (resJ) => {
                    this.parseServerData(resJ);
                });
            }else {
                if(response.status === 422) {
                    response.json().then( (resJ) => {
                        this.setState({error: resJ});
                    }, (jsonParseFailure) => {
                        console.log(jsonParseFailure);
                    });
                }else {
                    response.json().then( (resJ) => {
                        this.setState({error: resJ, hasServerError: true})
                    }, (jsonParseFailure) => {
                        console.log(jsonParseFailure);
                    });
                }
            }
            }, (rejection) => {
                this.setState({clientError: true});
                console.log(rejection)
            })

    }

    parseServerData(result) {
        let newState = {
            imageUrl: result.imageURL_banner,
            loading: false,
            name: result.name,
            description: result.description
        };
        let itemNavs = result.item_navigations;
        // AnalyticsManager.registerItemImpressions(itemNavs, result.name);
        GoogleAnalytics.viewCategory(result.name);
        newState.items = itemNavs;
        this.setState(newState);
    }


    render() {
        let rewritableContent = this.props.content;
        if(!this.state.items || this.state.items.length <= 0) {
            rewritableContent = (
                <div className='text-center mt-3 mb-2'>
                    <h3>Your cart is empty, why not <a href={`${window.relativeURI()}/menu`}>add some food?</a></h3>
                    <a href={`${window.relativeURI()}/menu`} className='btn btn-primary'>Return to Menu</a>
                </div>
            )
        }
        return (
            <CategoryContext.Provider value={this.state}>
                <RecurveBaseComponent loading={this.state.loading} error={this.state.error} hasServerError={this.state.hasServerError} hasPopupError={this.state.hasPopupError} content={rewritableContent} />
            </CategoryContext.Provider>
        );
    }
}
export {Category, CategoryContext};
